import { types, flow } from 'mobx-state-tree';

import * as API from '@src/services/freelancers';
import { ApiStore } from '@src/features/common';

export const Dashboard = types
  .compose(
    ApiStore,
    types.model({
      stats: types.frozen(),
      statistics: types.frozen()
    })
  )
  .actions(self => {
    return {
      fetchData: flow(function* fetch(userId) {
        self.stats = yield self.fetch(API.getDashboardStats());
        self.statistics = yield self.fetch(API.getStatistics(userId));
      })
    };
  });
